
import HeaderSession from "../../../../utils/headerSession";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import Loading from "../../../../load/loading";
import CardInspeccao from "./avfd/cardInspeccao";
import RegisterAccess from "../../../../utils/registerAccess";
import FichaEstabelecimento from "../../../gestLicenciados/fichaEstabelecimento";
import { Card, DialogActions, MenuItem, TextField, Container } from "@mui/material";
import ListaVazia from "../../../../utils/listaVazia";
import InspeccaoRealizada from "./avfd/inspeccaoRealizada";
import FichaDirectorTecnico from "../../../gestDirectorTecnico/fichaDirectorTecnico";
import { useSearchParams } from "react-router-dom";
import Paginacao from "../../../../utils/paginacao";
import ButtonLeft from "../../../../utils/buttonLeft";

export default function InspeccaoByInspector({ element: component, ...rest }) {
    const user = useSelector(state => state.account.user);
    const [inspeccoes, setInspeccoes] = useState('');
    const [status, setStatus] = useState('Não Realizada');
    const [configLista, setConfigLista] = useState('');
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));
    const [perPage, setPerPage] = useState(20);

    const [directorTecnico, setDirectorTecnico] = useState(false);

    useEffect(() => {
        // api.get(`/inspeccaos`)
        setInspeccoes('')
        // api.get(`/inspeccaos?inspectorId=${'66df5e733fadbecde1744c84'}&status=${status}&perPage=${perPage}&page=${page}`)
            api.get(`/inspeccaos?inspectorId=${user._id}&status=${status}&perPage=${perPage}&page=${page}`)
            .then(response => {
                // console.log(response)
                setInspeccoes(response.data.inspeccaos);
                setConfigLista(response.data);
            }).catch(err => 'console.log(err)')
    }, [user._id, status, page, perPage]);

    return (
        <Container style={{ maxWidth: 900, padding: 8 }}>
            <RegisterAccess page={'ver inspeccao por inspector'} />
            <HeaderSession title={'MINHAS INSPECÇÕES'} />

            <DialogActions>
                <TextField
                    style={{ width: 200 }}
                    type="text"
                    placeholder="Categoria"
                    select
                    size="small"
                    variant="outlined"
                    onChange={(e) => { setStatus(e.target.value === 'Geral' ? '' : e.target.value) }}
                    defaultValue={'Não Realizada'}
                >
                    <MenuItem key='Não Realizada' value='Não Realizada'>
                        Não Realizada
                    </MenuItem>
                    <MenuItem key='Realizada' value='Realizada'>
                        Realizada
                    </MenuItem>
                    <MenuItem key='Reprovada' value='Reprovada'>
                        Reprovada
                    </MenuItem>
                    <MenuItem key='Geral' value='Geral'>
                        Geral
                    </MenuItem>
                </TextField>
            </DialogActions>

            {inspeccoes ?
                <>
                    {
                        inspeccoes.map((inspeccao, index) =>
                            inspeccao.status === 'Realizada' ?
                                <InspeccaoRealizada key={inspeccao._id} inspeccaoId={inspeccao._id} />
                                :
                                <Card key={inspeccao._id} style={{ marginBottom: 30 }}>
                                    <CardInspeccao thisInspeccao={inspeccao} />
                                    <FichaEstabelecimento menu={false} estabelecimento={inspeccao?.estabelecimento} />
                                    {directorTecnico === inspeccao?._id ?
                                        <FichaDirectorTecnico header={true} menu={false} directorTecnico={inspeccao?.estabelecimento?.directorTecnico} />
                                        :
                                        <ButtonLeft title={'Ver Director Técnico'} funcao={() => { setDirectorTecnico(inspeccao?._id) }} />
                                    }

                                </Card>
                        )}
                    <Card >
                        <Paginacao
                            configLista={configLista}
                            lista={inspeccoes}
                            page={page}
                            setPage={setPage}
                            setPerPage={setPerPage}
                        // setOrder={setOrder}
                        />
                    </Card>
                </>
                :
                <Loading />
            }

            {inspeccoes && inspeccoes.length < 1 && <ListaVazia text={'Nenhuma inspecção encontrada.!'} />}
        </Container>
    )
}